import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFnsJalali } from "@mui/x-date-pickers/AdapterDateFnsJalaliV3";
import { faIR as muiFaIR } from "@mui/x-date-pickers/locales";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { parseISO } from "date-fns";
import { faIR as dateFnsFaIR } from "date-fns-jalali/locale";
import { formatToIso } from "functions/dateTime";
import { useState } from "react";
import { Controller } from "react-hook-form";
import RightToLeftLayout from "../RightToLeft";
import classes from "./style.module.scss";

const DatePickerField = ({
  name,
  required = false,
  control,
  fullWidth = true,
  variant = "outlined",
  label,
  className = "",
  size = "small",
  theme = 1,
  ...rest
}) => {
  const [open, setOpen] = useState(false);

  return (
    <RightToLeftLayout>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <div onClick={() => setOpen(true)} style={{ cursor: "pointer" }}>
            <LocalizationProvider
              dateAdapter={AdapterDateFnsJalali}
              adapterLocale={dateFnsFaIR}
              localeText={muiFaIR.components.MuiLocalizationProvider.defaultProps.localeText}
            >
              <MuiDatePicker
                {...field}
                label={label}
                onChange={(newValue) => {
                  const value = newValue ? formatToIso(newValue) : null;
                  field.onChange(value);
                }}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                value={field.value ? parseISO(field.value) : null}
                sx={{
                  "& button": {
                    width: "auto",
                  },
                  "& .MuiInputLabel-asterisk": {
                    color: "red",
                  },
                }}
                className={`${className} ${theme === 2 && classes.fieldTheme2}`}
                slotProps={{
                  textField: {
                    fullWidth,
                    required,
                    variant,
                    size: size,
                    error: !!error,
                    helperText: error?.message,
                  },
                  desktopPaper: { dir: "rtl" },
                  mobilePaper: { dir: "rtl" },
                }}
                {...rest}
              />
            </LocalizationProvider>
          </div>
        )}
      />
    </RightToLeftLayout>
  );
};

export default DatePickerField;
